import React from 'react';
import { Text, Card, BlockStack } from '@shopify/polaris';

export function HelpSection() {
  return (
    <Card>
      <BlockStack gap="loose" align="center">
        <Text variant="headingMd" fontWeight="bold" as="h2">
          Need Help?
        </Text>
        <Text variant="bodyMd" as="p" color="subdued">
          For detailed documentation and troubleshooting guides, visit our{' '}
          <a 
            href="https://help.shopify.com/admin-app" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#008060', textDecoration: 'underline' }}
          >
            Help Center
          </a>
          {' '}or contact our{' '}
          <a 
            href="mailto:support@shopify.com" 
            style={{ color: '#008060', textDecoration: 'underline' }}
          >
            Support Team
          </a>
          .
        </Text>
      </BlockStack>
    </Card>
  );
}
